{
  "open": "Remote desktop",
  "unavailable": "This installation of the panel has no remote desktop: there is no RDP gateway. Ask your administrator.",
  "picker": {
    "kind": "How to connect",
    "ssh": "Terminal (SSH)",
    "sshHint": "The command line of Linux and other Unix systems.",
    "rdp": "Remote desktop (RDP)",
    "rdpHint": "The Windows desktop in a browser window: mouse, keyboard, clipboard.",
    "vnc": "Console (VNC)",
    "vncHint": "The server's screen, like a monitor: works without network or SSH, shows boot and kernel errors.",
    "vncNote": "The console opens as a tab. Sign in on the server's screen as at its monitor: the system asks for the password itself."
  },
  "signIn": {
    "user": "Windows user",
    "userHint": "Administrator by default. The panel remembers the name for this server.",
    "password": "Password",
    "passwordHint": "Needed for one sign-in: the panel neither stores nor logs it. Type it again to reconnect.",
    "domain": "Domain (optional)",
    "domainHint": "Only for Active Directory domain accounts."
  },
  "reach": {
    "title": "Access to port 3389",
    "open": "Open to the panel.",
    "blocked": "Closed by a firewall: {{names}}. The panel cannot connect.",
    "unknown": "The panel's address is not set, so the rules cannot be checked: port 3389 is not open to everyone.",
    "noAddress": "The server has no public address for the desktop to reach.",
    "allowHint": "Adds a rule to the firewall “{{name}}”: inbound TCP 3389 from {{ips}}.",
    "exposed": "Port 3389 is open to the whole internet: people will try passwords on this server. Close it with a firewall and allow only the panel's address."
  },
  "status": {
    "signingIn": "Signing in to Windows…"
  },
  "failure": {
    "unreachable": {
      "title": "The server does not answer on RDP",
      "text": "The gateway could not connect to port 3389. A firewall may block it, the remote desktop may be off in Windows, or the server is still starting."
    },
    "timeout": {
      "title": "The server did not answer in time",
      "text": "The connection did not open in time. Check the firewall and that Windows has started."
    },
    "auth_failed": {
      "title": "Windows refused the sign-in",
      "text": "Wrong user name or password — or Network Level Authentication (NLA) is off on the server, and the panel connects only with it."
    },
    "forbidden": {
      "title": "This account may not sign in",
      "text": "The password is right, but Windows refuses: the account is locked or disabled, the password expired, or it has no right to sign in through the remote desktop."
    },
    "session_conflict": {
      "title": "Another connection took the session",
      "text": "Someone else connected to this desktop (or you did from another device). Sign in again to take the session back."
    },
    "gateway_unavailable": {
      "title": "The RDP gateway is unavailable",
      "text": "The service the panel connects to desktops through does not answer. Try later or ask your administrator."
    },
    "gateway_error": {
      "title": "RDP gateway error",
      "text": "The gateway could not open the desktop. Try again; if it happens again, ask your administrator."
    },
    "idle": {
      "title": "Closed after inactivity",
      "text": "No keys and no mouse for 30 minutes. Sign in again — programs in Windows keep running."
    },
    "lifetime": {
      "title": "The session ended",
      "text": "A session lasts up to 8 hours. Sign in again to continue."
    },
    "closed": {
      "title": "Session closed",
      "text": "The connection to the desktop ended. Sign in again to continue."
    },
    "expired": {
      "title": "Session expired",
      "text": "The connection link was already used or has expired. Sign in again."
    }
  },
  "workspace": {
    "title": "Remote desktop of {{name}}",
    "signIn": "Sign in"
  },
  "clipboard": {
    "remoteEmpty": "The desktop's clipboard is empty: copy the text in Windows first.",
    "copy": "Copy from the desktop's clipboard",
    "copied": "The desktop's clipboard is on yours now",
    "sent": "The text is on the desktop's clipboard: paste it there with Ctrl+V",
    "readFailed": "The browser did not let the panel read the clipboard. Type the text in the window: it is typed on the desktop with keys."
  },
  "setup": {
    "title": "Remote desktop",
    "intro": "The panel opens the Windows desktop right in the browser, in a tab of the top bar. The Windows user and password are typed for each session and stored nowhere. The server needs the remote desktop turned on, with Network Level Authentication (NLA)."
  }
}
